import { st } from "rdflib";
import { vcard } from "../namespaces.js";
export function removeEmailAddress(contactNode, emailNode, store) {
    const emailStatements = store.statementsMatching(emailNode, null, null, emailNode.doc());
    return {
        insertions: [],
        deletions: [
            ...emailStatements,
            st(contactNode, vcard("hasEmail"), emailNode, contactNode.doc()),
        ],
        filesToCreate: [],
    };
}
//# sourceMappingURL=removeEmailAddress.js.map